import { FileText, ShieldCheck, Megaphone, BookOpen } from "lucide-react";

const lifecycle = [
  {
    icon: FileText, title: "1. Document",
    desc: "People submit real bias scenarios and incident reports — text, video reenactments, personal stories. The community votes on whether it's bias and how serious it is. This is step one: getting real experiences out of memory and into a record.",
  },
  {
    icon: ShieldCheck, title: "2. Analyze",
    desc: "Individual incidents mean something on their own, but patterns mean more. We track which businesses, industries, regions, and situations show up again and again in documented behavior — turning isolated stories into evidence of a pattern.",
  },
  {
    icon: Megaphone, title: "3. Advocate & Lobby",
    desc: "This is where BBAP becomes more than a data collector. We use documented patterns to push for real institutional change — specifically, lobbying for pre-employment bias and personality screening to become standard practice, especially for roles that deal directly with the public. We also encourage businesses to adopt bias-free hiring and workplace practices, and make the case that a bias-free environment is simply good for business: if you want the trust and money of the communities you serve, treating people with dignity is in your own interest.",
  },
  {
    icon: BookOpen, title: "4. Recognize",
    desc: "The BBAP Book highlights businesses already doing this right — a modern directory of places that treat people with dignity, so the communities most affected know exactly where they're welcome.",
  },
];

export function LifecycleList() {
  return (
    <div className="space-y-6 mb-16">
      {lifecycle.map((l) => (
        <div key={l.title} className="flex gap-5 bg-white border border-zinc-200 rounded-sm p-6 hover:border-zinc-400 transition-all">
          <div className="shrink-0 h-11 w-11 rounded-full border border-[#4FD1C5]/40 flex items-center justify-center">
            <l.icon className="h-5 w-5 text-[#1E3A6E]" />
          </div>
          <div>
            <h3 className="font-display font-bold text-lg text-zinc-950 mb-2">{l.title}</h3>
            <p className="text-zinc-600 text-sm leading-relaxed">{l.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
